import SimpleCode from './SimpleCode';



export default SimpleCode;